export function onConfigLoaded(cb: () => void) {
  if (window.CONFIG_LOADED === true) {
    cb();
  } else {
    window.onConfigLoad = cb;
  }
}
